import { Outlet } from "react-router-dom";

export default function Users() {
	return (
		<div className='recipes-page page'>
			<Outlet />
		</div>
	);
}
